import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPageWidthLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/pageWidth" */ './PageWidth'), 'PageWidthLayout');
